import { useNativeState } from '@shared/core/native';
import { withWindow } from '@shared/utils/withWindow';
import { config } from '@static/js/env.config';
import { useState } from 'react';

export const ShowDevAlert = () => {
  const [shouldShowDevAlert, setShouldShowDevAlert] = useState(config.joyEnvironment === 'development');
  const isNative = useNativeState();

  // Native devices are responsible for ensuring the domain is correct when in webview
  if (shouldShowDevAlert && !isNative) {
    withWindow(() => {
      if (
        !window.confirm('This is a test environment for the Joy engineering team. Are you sure you want to create an event here? Click cancel to be redirected to our main site.')
      ) {
        window.location.href = 'https://withjoy.com/createwedding';
      }

      setShouldShowDevAlert(false);
    });
  }

  return null;
};
